// Checks a logo shows something by drawing it small: some sites serve blank or transparent icons (US 9370)
export function isVisible(src) {
  return new Promise(function(resolve) {
    let image = new Image();
    image.onload = function() {
      try {
        let size = 24;
        let canvas = document.createElement('canvas');
        canvas.width = size;
        canvas.height = size;
        let context = canvas.getContext('2d');
        context.drawImage(image, 0, 0, size, size);
        let pixels = context.getImageData(0, 0, size, size).data;
        let colours = {};
        for (let i = 0; i < pixels.length; i += 4) {
          if (pixels[i + 3] > 40) {
            colours[(pixels[i] >> 5) + '-' + (pixels[i + 1] >> 5) + '-' + (pixels[i + 2] >> 5)] = true;
          }
        }
        resolve(Object.keys(colours).length > 1);
      } catch (e) {
        resolve(true);
      }
    };
    image.onerror = function() {
      resolve(false);
    };
    image.src = src;
  });
}

// Only the logos that show something, in the same order
export function visibleOnly(candidates) {
  return Promise.all(candidates.map(candidate => isVisible(candidate.image)))
    .then(visible => candidates.filter((candidate, index) => visible[index]));
}

export function hostOf(url) {
  try {
    return new URL(url).host;
  } catch (e) {
    return url;
  }
}
